import { push } from '@lagunovsky/redux-react-router'
import {
    ERROR_LOGIN,
    LOCATION_LOGIN_REQUESTED,
    fetchLocationLoginSuccess,
    DOCUMENTTYPE_LOGIN_REQUESTED,
    COUNTRYCODE_LOGIN_REQUESTED,
    fetchCountryCodeLoginSuccess,
    AVAILABLE_LOGOUT_REQUESTED
} from '../modules/login/actions'
import { call, put, take, takeLatest, all } from 'redux-saga/effects'

import { googleServices } from '../../services/googleServices'
import { getCountryCode, getCountryDial } from '../../utils/schemas/login'

import country from '../../assets/json/country.json'
import { getLoginRedirectPath } from '../../utils/authSession'

export function* getLocation(action) {
    try {
        const response = yield call(googleServices.getLocation, action.payload)
        yield put(fetchLocationLoginSuccess(getCountryCode(country, response.data)))
    } catch (error) {
        console.error(error)
    }
}

export function* getCountry(action) {
    try {
        yield put(fetchCountryCodeLoginSuccess(getCountryDial(country, action.payload)))
    } catch (error) {
        console.error(error)
    }
}

export function* logout() {
    try {
        yield put(push(getLoginRedirectPath()))
    } catch (error) {
        console.error(error)
    }
}

export default function* loginWatcherSaga() {
    yield all([
        take(ERROR_LOGIN),
        take(DOCUMENTTYPE_LOGIN_REQUESTED),
        yield takeLatest(AVAILABLE_LOGOUT_REQUESTED, logout),
        yield takeLatest(COUNTRYCODE_LOGIN_REQUESTED, getCountry),
        yield takeLatest(LOCATION_LOGIN_REQUESTED, getLocation),
    ])
}
